import type { Entry as UserEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"
import type {
  RxQueryResult,
  UseRxQueryOptions,
} from "rxdb-hooks"
import { useEntryLoading } from "src/contexts/LoadingContexts"
import { useFindWithLoading } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useFindUserEntries<T extends UserEntry>(
  queryObject: MangoQuery<T>,
  options?: Omit<UseRxQueryOptions, "json">,
): RxQueryResult<T> {
  const loadingContextValue = useEntryLoading()

  return useFindWithLoading<T>(
    loadingContextValue,
    CollectionKey.UserEntry,
    queryObject,
    options,
  )
}
